import { ChangeDetectionStrategy, Component, Inject, Input } from '@angular/core';
import { IAvailableLanguage, IDataService, IParsedDataResponse } from '../../services/data/data-service.interface';
import { BrowserWindowRef } from '../../services/window/window.service';
import moment from 'moment';
import 'moment/locale/pt';
@Component({
  selector: 'gtd-language-menu',
  templateUrl: './language-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageMenuComponent {
  @Input() cssClass = '';
  public currentLanguage: string;
  public globalData: IParsedDataResponse;
  public availableLanguages: IAvailableLanguage[];

  constructor(@Inject(BrowserWindowRef) private window: BrowserWindowRef, @Inject('IDataService') private dataService: IDataService) {
    this.globalData = this.dataService.getData();
    this.availableLanguages = Object.values(this.globalData.available_languages);
    this.currentLanguage = this.globalData.current_language;
    moment.locale(this.currentLanguage);
  }

  public selectLanguage(language: string): void {
    moment.locale(language);
    if (language !== this.currentLanguage) {
      window.location.href = this.window.nativeWindow.location.href.replace(this.currentLanguage, language);
    }
  }
}
